<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="30"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Services</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2">
                    <div class="mb-1">Nuværende valg:</div>
                    <div>Standard afhentning fra kantsten</div>
                    <div>
                        Afhentning mellem kl.
                        {{ getPickupTime(booking, 'start', configurations['default_time_from_pickup'].value) }} -
                        {{ getPickupTime(booking, 'end', configurations['default_time_to_pickup'].value) }}
                    </div>
                </div>
                <br>
                <div class="mb-2">
                    <div class="mb-1">Se mulige tilvalg:</div>
                    <div v-for="(item, key) in additionalServices"
                         v-if="[additionalServiceShorterTimeInterval].includes(key)"
                    >
                        <div class="d-flex mb-1">
                            <input type="checkbox"
                                   :id="`additional-${key}`"
                                   v-model="item.enabled"
                            >
                            <label class="ml-2 mb-0" :for="`additional-${key}`">
                                {{ item.name }}
                            </label>
                        </div>
                        <div v-if="key === additionalServiceShorterTimeInterval && item.enabled"
                             class="mb-2"
                        >
                            <div class="align-items-center bg-white rounded-lg div-focus">
                                <select v-model="additionalServices[key].value"
                                        class="form-control"
                                        @change="onChangeShorterTimeInterval">
                                    <option value=""></option>
                                    <option v-for="interval in shorterTimeIntervals"
                                            :value="interval"
                                    >
                                        {{ interval.when }} {{ interval.time }} ({{ interval.price }} kr.)
                                    </option>
                                </select>
                            </div>
                            <div class="text-danger" v-if="errors[additionalServiceShorterTimeInterval]">
                                {{ errors[additionalServiceShorterTimeInterval] }}
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div>
                    <button class="btn btn-success" @click="goNext">Næste STEP</button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            Din levering vil blive opgraderet til en STEP PRIME levering.
                            Da din levering nu vil kræve 2 knivskarpe chauffører, betyder det at din leveringsdag rykkes.
                            Du adviseres altid med leveringsdatoen 2 dage i forvejen, samt et 4-timers interval for leveringen dagen før.
                            Forbered dig bedst muligt på din levering via vores kundeguide.
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary mb-1" data-dismiss="modal" @click="toggleModal">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <modal-iframe ref="modal-iframe"
                      @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeModalInterval || activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "../reusable/ProgressBar.vue";
import BackSection from "../reusable/BackSection.vue";
import ModalIframe from "../reusable/ModalIframe.vue";
import FlashError from "../reusable/FlashError.vue";
import priceMixin from "../../../mixins/priceMixin";
import dateTimeMixin from "../../../mixins/dateTimeMixin";
import moment from "moment";
export default {
    name: "CmfPickupStep2",
    components: {FlashError, ProgressBar, BackSection, ModalIframe},
    mixins: [priceMixin, dateTimeMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServiceShorterTimeInterval: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
    },
    data() {
        return {
            activeIframeModalInterval: false,
            activeModalInterval: false,
            show: false,
            additionalServices: this.additionalServicesProp.length === undefined ? this.additionalServicesProp : {},
            shorterTimeIntervals: {},
            errors: {},
        }
    },
    created() {
        if (this.configurations.shorter_time_intervals_pickup) {
            this.shorterTimeIntervals = JSON.parse(this.configurations.shorter_time_intervals_pickup.value);
            for (let i in this.shorterTimeIntervals) {
                if (this.shorterTimeIntervals[i].price > 0) {
                    this.$set(
                        this.shorterTimeIntervals[i],
                        'price',
                        this.calculatePriceWithVatAndRoundToNearestTens(this.shorterTimeIntervals[i].price)
                    );
                }
            }
        }

        if (!this.additionalServices[this.additionalServiceShorterTimeInterval]) {
            this.$set(this.additionalServices, this.additionalServiceShorterTimeInterval, {
                key: this.additionalServiceShorterTimeInterval,
                name: 'Kortere tidsinterval',
                value: '',
                price: 0,
                enabled: false
            });
        }

        // Check shorter_time_interval_cut_off_time_pickup
        // https://app.asana.com/0/1201636296551651/1207809971532795

        // UNCOMMENT if other options will be available on this page

        // if (this.configurations.shorter_time_interval_cut_off_time_pickup &&
        //     this.configurations.shorter_time_interval_cut_off_time_pickup.value &&
        //     this.booking.pickup_end
        // ) {
        //     this.$set(
        //         this.configurations.shorter_time_interval_cut_off_time_pickup,
        //         'value',
        //         JSON.parse(this.configurations.shorter_time_interval_cut_off_time_pickup.value)
        //     );
        //
        //     if (this.configurations.shorter_time_interval_cut_off_time_pickup.value.enabled &&
        //         this.configurations.shorter_time_interval_cut_off_time_pickup.value.day &&
        //         this.configurations.shorter_time_interval_cut_off_time_pickup.value.time
        //     ) {
        //         let pickupDate = moment(this.booking.pickup_end);
        //         let cutOffDay = this.configurations.shorter_time_interval_cut_off_time_pickup.value.day;
        //         let time = this.configurations.shorter_time_interval_cut_off_time_pickup.value.time.split(':');
        //         if (cutOffDay === this.today) {
        //             cutOffDay = moment();
        //         } else if (cutOffDay === this.tomorrow) {
        //             cutOffDay = moment().add(1, 'days');
        //         } else {
        //             cutOffDay = moment().add(2, 'days');
        //         }
        //         cutOffDay.hours(time[0]);
        //         cutOffDay.minutes(time[1]);
        //         cutOffDay.seconds(0);
        //         if (cutOffDay.isAfter(pickupDate)) {
        //             this.$delete(this.additionalServices, this.additionalServiceShorterTimeInterval);
        //         }
        //     }
        // }
        // ************
    },
    methods: {
        validate() {
            this.errors = {};

            let arr = [this.additionalServiceShorterTimeInterval];

            for (let i = 0; i < arr.length; i++) {
                if (this.additionalServices[arr[i]] &&
                    this.additionalServices[arr[i]].enabled &&
                    !this.additionalServices[arr[i]].value
                ) {
                    this.$set(this.errors, arr[i], 'The value can\'t be empty');
                }
            }
        },
        goNext() {
            this.validate();
            setTimeout(() => {
                if (!Object.keys(this.errors).length) {
                    axios.post(this.applyChangesUrl, this.additionalServices)
                        .then((response) => {
                            window.location.href = this.nextUrl;

                        }).catch(error => {
                        this.$refs.flashError.flashError(error);
                    });
                }
            }, 50);

        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        onChangeShorterTimeInterval() {
            setTimeout(() => {
                if (this.additionalServices[this.additionalServiceShorterTimeInterval]['value']) {
                    for (let i in this.shorterTimeIntervals) {
                        if (this.additionalServices[this.additionalServiceShorterTimeInterval]['value']['when'] ===
                            this.shorterTimeIntervals[i]['when'] &&
                            this.additionalServices[this.additionalServiceShorterTimeInterval]['value']['time'] ===
                            this.shorterTimeIntervals[i]['time']
                        ) {
                            this.$set(this.additionalServices[this.additionalServiceShorterTimeInterval],
                                'price',
                                this.shorterTimeIntervals[i]['price']
                            );
                        }
                    }
                } else {
                    this.$set(this.additionalServices[this.additionalServiceShorterTimeInterval], 'price', 0);
                }

            }, 500);
        },
    },
}

</script>

<style scoped>

</style>
